import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import ProductPreviewSection from "@/components/ProductPreviewSection";
import AudienceSection from "@/components/AudienceSection";
import CredibilitySection from "@/components/CredibilitySection";
import WhoWeAre from "@/components/WhoWeAre";
import WhatItDoes from "@/components/WhatItDoes";
import SimulatorSection from "@/components/SimulatorSection";
import AccessRequestSection from "@/components/AccessRequestSection";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <Manifesto />
      <ProductPreviewSection />
      <AudienceSection />
      <CredibilitySection />
      <WhoWeAre />
      <WhatItDoes />
      <SimulatorSection />
      <AccessRequestSection />
    </main>
  );
}
